import { Injectable } from '@angular/core';
/*import { Http, RequestOptionsArgs, RequestOptions } from '@angular/http';*/
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { RootObject } from './vimeo';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'bearer a6242daa4421a7cbb79aba88ed5e70a0',

  })
};

@Injectable({
  providedIn: 'root'
})
export class VimeoService {

  constructor(private http: HttpClient) { }

  public GetVideoData() {

    var response = this.http.get('https://api.vimeo.com/videos/321401473', httpOptions).subscribe(event => {
      console.log(event); // handle event here
      //return event.pictures.sizes.last();
    });
  }
}
